<template>
  <div class="flip-container page-container">
    <v-header></v-header>
    <div class="page-wrap">
      <div class="content">
        <div class="main">
          <div class="image-main-container">
            <div class="image-editor">
              <ImageEditor
                ref="tuiImageEditor"
                :include-ui="useDefaultUI" 
                :options="options"
              >
              </ImageEditor>
              <div class="side-menu">
                <div class="rotate-item" style="margin-right:50px" @click="rotateFromButton(90)">
                  <img src="@/assets/images/page/rotate-left.png" alt="">
                  <label>90°</label>
                </div>
                <div class="rotate-item" @click="rotateFromButton(-90)">
                  <img src="@/assets/images/page/rotate-right.png" alt="">
                  <label>90°</label>
                </div>
              </div>
              <div class="rule-wrap">
                <v-rules
                  @post-NumValue="rulerNum"
                  @scroll-start='startEvent'
                  :NowNum='NowNum' 
                  :maxNum='18' 
                  :minNum='-18' 
                  :ruleWidth='20' 
                  :numSize='14' 
                  :oneGridValue="5"
                ></v-rules>
              </div>
              <div class="upload-tips" v-if="!fileList.length">
                <p>支持图片批量镜像操作</p>
                <el-upload
                  action="#"
                  accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                  :file-list="fileList"
                  ref="dynamic"
                  :limit="IMAGE_LIMIT"
                  :on-change="handleChanged"
                  :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  multiple
                >
                  <el-button size="large" type="default" class="upload-button">点击上传图片</el-button>
                </el-upload>
              </div>
            </div>

            <!-- 图片墙 -->
            <div class="image-list">
              <el-upload
                action="string"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                ref="dynamic"
                :file-list="fileList"
                :limit="IMAGE_LIMIT"
                :show-file-list="true"
                :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                :on-change="handleChanged"
                :auto-upload="false"
                :on-remove="handleRemove"
                multiple
              >
                <i class="el-icon-plus"></i>
                <div slot="file" 
                  slot-scope="{file}" 
                  :class="[file.isActive ? 'active' : '']"  
                  @click="selectCurrentImage(file)"
                >
                  <img
                   style="width:100%;height:100%;object-fit:contain"
                   :src="file.url" 
                  />
                  <el-checkbox 
                    class="images-checkbox"
                    v-model="file.checked"
                    @click.stop.native="() => {}"
                    @change="(value) => changeSelected(value, file)" 
                    :checked="file.checked"
                  >
                  </el-checkbox>
                  <div class="delete-images" @click.stop="handleRemove(file)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
          </div>
          <!-- 右侧ad 展示以及分享 -->
          <div class="main-ad">
            <v-google-adsense></v-google-adsense>
            <div class="share">
              <v-share></v-share>
              <v-download :fileList="imageList"></v-download>
              <v-link-to :hideFlip="true" :fileList="imageList"></v-link-to>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入样式  
import "tui-image-editor/dist/tui-image-editor.css";  
import "tui-color-picker/dist/tui-color-picker.css";  
// 引入组件  
import ImageEditor from "@toast-ui/vue-image-editor/src/ImageEditor.vue";
import Vue from 'vue';

export default {
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],

      // 与tui-image-editor 相关的配置
      useDefaultUI: true,
      options: {
        includeUI: {
          loadImage: {
            //加载一张空白的图片，否则无法使用编辑控件
            path: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
            name: '_black'
          },
          // 默认开启绘图的功能  
          initMenu: "flip",
          // 支持的菜单  
          // menu: this.TUI_IMAGE_EDITOR_MENULIST,
          menu: ["flip"],
          locale: this.TUI_IMAGE_EDITOR_LOCALE_ZH,
          theme: this.TUI_IMAGE_EDITOR_CUSTOM_THEME,
          // theme: whiteTheme,
          // 菜单位置在左边 
          menuBarPosition: "left", 
        },
        cssMaxWidth: document.body.offsetWidth - 600,
        cssMaxHeight: document.body.offsetHeight - 250,
      },

      // 选中当前图片
      currentImage: {
        width: null,
        height: null,
        base64Url: '',
        url: '',
        uid: ''
      },

      tuiImageEditor: {},
      flipStatus: [],  // 镜像的旋转状态
      customAngle: 0, //自定义的角度,实际上作用的角度
      tempCustomAngle: 0, // 多定义这个属性，是为了在图片不被选中时，也能旋转，只是不会被作用到其他的已选中的图片上。
      preRotateValue: 0, //这个属性是用来刻度尺使用的
      NowNum: 0, // 刻度尺当前的值
      rotateByBottonList: [] //这个是为了记录所有的旋转角度，是为了让所做的操作作用在新上传的图片上
    }
  },
  computed: {
    limit () {
      return parseInt(this.IMAGE_LIMIT - this.fileList.length);
    },
    imageList () {
      return this.fileList.filter(item => item.checked == true);
    },
  },
  created() {
    this.$nextTick(function () {
      this.tuiImageEditor = this.$refs.tuiImageEditor;
    })
  },

  mounted () {
    // 取消按钮
    this.cancel();

    // cancel
    this.cancelObject = document.querySelector('.cancel-custom');
    this.flipButtonObject = document.querySelector('.tie-flip-button');

    // 监听取消事件
    this.cancelObject.addEventListener('click', () => {
      this.handleCancel();
    });

    // 监听点击事件
    this.flipButtonObject.addEventListener('click', this.changeFlip);
  },
  
  methods: {
    rulerNum (value) {
      if (!this.currentImage) {
        return;
      }
      if (this.currentImage.checked) {
        this.customAngle = value
        this.$set(this.rotateByBottonList, 1, this.customAngle)
        this.applyRotate(this.customAngle, true)
      } else {
        this.tempCustomAngle = value
       
        this.tuiImageEditor.invoke('loadImageFromURL', this.currentImage._base64Url, this.currentImage.name)
          .then((res) => {
            this.tuiImageEditor.invoke('rotate', this.tempCustomAngle).then(() => {
              var base64Url = this.tuiImageEditor.invoke('toDataURL');
              this.currentImage.base64Url = base64Url;
              this.setFileList(this.currentImage)
            })
        })
      }
    },

    startEvent () {
      this.preRotateValue = this.customAngle
    },

    // 加这个函数是因为，在连续使用刻度尺进行旋转的时候，每一次基础的图片都不能是前一次旋转的的图片，而是【通过button旋转、镜像旋转、原始图】为基础。
    // 如果每一次旋转的基础图片都是上一次使用刻度尺进行旋转的图片，那么会出现图越来越小的情况。
    setBase64UrlToUseRuleNumToRatate () {
      this.imageList.map(item=> {
        item._base64Url = item.base64Url
        if (item.uid== this.currentImage.uid) {
          this.currentImage._base64Url = item._base64Url
        }
        this.setFileList(item)
      })
    },


    cancel () {
      const div = document.createElement('div');
      document.querySelector('.tui-image-editor-submenu-item').appendChild(div);

      const tar = new Vue({
        el: div,
        template: `
          <el-button size="medium" class="cancel-custom" ref="cancelObject">重置</el-button>`,
      });
      return tar;
    },

    changeFlip (event) {
      const button = event.target.closest('.tui-image-editor-button');
      if (button) {
        const flipType = this.getFlipButtonType(button, ['flipX', 'flipY']);
        if (!this.currentImage.checked) {
          this.setItemBase64ByFlip(this.currentImage, flipType)
          return
        }
        this.flipStatus.push(flipType);

        let setImageBase64UrlByFlipPromise = [];
        setImageBase64UrlByFlipPromise.push(this.setImageBase64UrlByFlip(flipType));

        Promise.all(setImageBase64UrlByFlipPromise)
          .then(() => {
            this.currentImage = Object.assign({}, this.fileList.find(item => item.uid === this.currentImage.uid))

            setTimeout(() => {
              this.tuiImageEditor.invoke('loadImageFromURL', this.currentImage.base64Url, this.currentImage.name)

              this.setBase64UrlToUseRuleNumToRatate()
            })
          })
      }
    },

    // 通过按钮来旋转
    rotateFromButton (value) {
      // 如果没有选中，则不被作用到全局图片中
      if (this.currentImage.checked) {
        this.customAngle = parseInt(this.customAngle, 10) + value
        this.$set(this.rotateByBottonList, 0, this.customAngle)
        this.applyRotate(value, false)
      } else {
        this.tempCustomAngle = parseInt(this.tempCustomAngle, 10) + value
        this.rotateCurrentImage(this.currentImage, value)
      }
    },

    // 先应用再选中，可以使用 changeSelected 来实现。
    // 先选中，再变换 applyRotate
    setItemBase64ByRatote (imageObject, angle, useRuleNumToRatate) {
      let url = useRuleNumToRatate ? imageObject._base64Url : imageObject.base64Url || imageObject.url
      return this.tuiImageEditor.invoke('loadImageFromURL', url, imageObject.name)
        .then(() => 
          this.tuiImageEditor.invoke('rotate', parseInt(angle))
            .then(() => {
              var base64Url = this.tuiImageEditor.invoke('toDataURL');
              imageObject.base64Url = base64Url;
              if (this.currentImage.uid == imageObject.uid) {
                this.currentImage.base64Url = imageObject.base64Url
              }
              this.setFileList(imageObject)
              return Promise.resolve()
            })
        )
    },

    async setImageBase64UrlByRotate (angle, useRuleNumToRatate) {
      for (let i = 0; i < this.imageList.length; i++) {
        await this.setItemBase64ByRatote(this.imageList[i], angle, useRuleNumToRatate);
      }
    },

    // 使用游标尺去旋转的时候注意：第二次旋转的基础图片不是第一次游标尺的base64的结果，而是点击左右90或者是镜像后的结果
    applyRotate (angle, useRuleNumToRatate) {
      // 当前作用的图片没有选中的时候，不管怎样怎么变换大小，都只是预览，并不会作用到其他图片上
      this.setImageBase64UrlByRotate(angle, useRuleNumToRatate).then(() => {
        let url = this.currentImage.base64Url || this.currentImage.url
        setTimeout(() => {
          
          this.tuiImageEditor.invoke('loadImageFromURL', url, this.currentImage.name)
          if (!useRuleNumToRatate) {
            this.setBase64UrlToUseRuleNumToRatate()
          }
        }, 5)
        
      })
    },

    setItemBase64ByFlip (imageObject, flipType) {
      let loadImageURL = imageObject.base64Url ? imageObject.base64Url : imageObject.url;

      return this.tuiImageEditor.invoke('loadImageFromURL', loadImageURL, imageObject.name)
        .then(() => 
          this.tuiImageEditor.invoke(`${flipType}`)
            .then(() => {
              var base64Url = this.tuiImageEditor.invoke('toDataURL');
              imageObject.base64Url = base64Url;
              // 保存这个作用的结果，做为自由旋转的初始值。
              imageObject._base64Url = base64Url;
              if (this.currentImage.uid == imageObject.uid) {
                this.currentImage.base64Url = imageObject.base64Url
              }
              this.setFileList(imageObject);
            })
        )
    },

    async setImageBase64UrlByFlip (flipType) {
      for (let i = 0; i < this.imageList.length; i++) {
        const imgObject = this.imageList[i];
        await this.setItemBase64ByFlip(imgObject, flipType);
      }
    },

    getFlipButtonType(button, buttonNames) {
      return button.className.match(RegExp(`(${buttonNames.join('|')})`))[0];
    },

    // 自定义取消事件
    handleCancel () {
      this.flipStatus = []
      this.customAngle = 0
      this.tempCustomAngle = 0
      this.NowNum = 0
      this.rotateByBottonList = []

      this.fileList.map(item => {
        item.checked = false;
        item.base64Url = item.url;
        item._base64Url = item.url;
      })

      this.currentImage = this.fileList.find(item => item.uid === this.currentImage.uid);
      
      this.tuiImageEditor.invoke('loadImageFromURL', this.currentImage.url, this.currentImage.name);
    },

    // 张数限制
    handleExceed(files, fileList) {
      // 如果总数大于9 或者是 当前选择的大于9都不能再上传。
      if (this.fileList.length > this.IMAGE_LIMIT || files.length > this.limit) {
        this.$message.error(`您选择的图片总数大于${this.IMAGE_LIMIT}张,您还可以选择${this.limit}张`)
      }
    },

    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    handleChanged (file, fileList) {
      fileList.forEach((item,index) => {
        // 当之前没有任何图片，也就是每一次上传的时候，如果之前没有选中任何图片，就默认选中第一张。
        item.checked = true;
        item.isActive = index ? false : true;
      })
      this.fileList = fileList;

      // 如果是第一次上传，则将第一个选中,且将操作的图片设置为第一张
      var readFilePromise = [];
      readFilePromise.push(this.readFile(file));

      Promise.all(readFilePromise)
        .then(() => {
          this.currentImage = Object.assign({}, this.fileList[0]);

          this.tuiImageEditor.invoke('loadImageFromFile', this.currentImage.raw)
            .then(res => {
              // 第一张图片被渲染出来
              this.currentImage.width = res.newWidth;
              this.currentImage.height = res.newHeight;
              this.setFileList(this.currentImage);

              if (!this.flipStatus.length && !this.rotateByBottonList.length) {
                return
              }

              // 之前做的操作也能被作用在新上传的图片上
              this.flipCurrentImage(file).then(() => {
                let angle = this.rotateByBottonList.reduce((prev, curr) => prev + curr)

                this.rotateCurrentImage(file, angle)
              })
            })
        })
    },

    readFile (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (arg) => {
          file.url = arg.target.result;
          file.base64Url = arg.target.result;
          file._base64Url = arg.target.result;
          this.setFileList(file);
          resolve(arg);
        };
        reader.onerror = reject;
      });
    },

    // 上传之前的钩子函数，限定上传图片的格式和大小
    checkImage (file, fileList) {
      let fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      var isImage = this.IMAGE_TYPE_LIMIT.indexOf(fileType) !== -1;
      var isLt10M = file.size / 1024 / 1024 < this.IMAGE_SIZE;

      if (!isImage) {
        this.$message.error('上传图片格式必须为jpg,jepg,png,jpg2,bmp,svg!');
        // return Promise.reject();
        return false;
      }

      if (!isLt10M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.IMAGE_SIZE}MB!`);
        return false;
      }
    },

    //删除
    handleRemove(file) {
      if (this.fileList.length == 1) {
        this.currentImage = {};
        this.customAngle = 0; //自定义旋转值
        this.tempCustomAngle = 0;
        this.flipStatus = [];
        this.rotateByBottonList = []

        this.tuiImageEditor.invoke('loadImageFromURL', this.options.includeUI.loadImage.path, this.options.includeUI.loadImage.name);
      }
      
      // 删除当前所选的文件
      let removeFileIndex = this.fileList.findIndex(item => item.uid == file.uid);

      //删除图片之后，将isActive换成当前图片列表的后面一个，如果删除的是最后一张图片，就选中第一张
      var nextSelectImageIndex = removeFileIndex == (this.fileList.length - 1) ? 0 : removeFileIndex;
      this.fileList.splice(removeFileIndex, 1);

      // 如果删除的是当前选中的图片，则需要跳到下一张图片去
      // 如果不是只有一张图片，则选中下一个图片,当删除的是当前所选的图片
      if (this.fileList.length && this.currentImage.uid == file.uid) {
        this.selectCurrentImage(this.fileList[nextSelectImageIndex]);
      }
    },

    // 当图片选中状态变化的时候触发的钩子函数
    changeSelected (value, file) {
      if (!this.imageList.length) {
        this.flipStatus = []
        this.customAngle = 0
        this.tempCustomAngle = 0
      }
      this.fileList.map(item => {
        item.isActive = false;
      });

      file.isActive = true;
      file.checked = value;
      this.currentImage = Object.assign({}, file);

      // 取消，展示原始图片，即使改变了大小也不会被保存
      if (!file.checked) {
        this.currentImage.base64Url = '';
        this.customAngle = 0;
        this.setFileList(this.currentImage);
        this.tuiImageEditor.invoke('loadImageFromURL', this.currentImage.url, this.currentImage.name)
        return;
      }

      //没做任何变换，只是选中
      if (!this.flipStatus.length && !this.rotateByBottonList.length) {
        this.tuiImageEditor.invoke('loadImageFromURL', this.currentImage.url, this.currentImage.name)
        return;
      }

      // 做了镜像变换，然后选中,
      this.flipCurrentImage(this.currentImage).then(() => {
        let angle = this.rotateByBottonList.reduce((prev, curr) => prev + curr)

        this.rotateCurrentImage(this.currentImage, angle)
      })
    },

    async flipCurrentImage (file) {
      for (let i = 0; i < this.flipStatus.length; i++) {
        let flipType = this.flipStatus[i];
        await this.setItemBase64ByFlip(file, flipType)
      }
    },

    rotateCurrentImage (imageObject, angle) {
      let url = imageObject.base64Url || imageObject.url
      return this.tuiImageEditor.invoke('loadImageFromURL', url, imageObject.name)
        .then(res => {
          this.tuiImageEditor.invoke('rotate', angle).then(() => {
            var base64Url = this.tuiImageEditor.invoke('toDataURL');
            imageObject.base64Url = base64Url;

            this.setFileList(imageObject)
          })
        })
    },

    setFileList (file) {
      this.$set(this.fileList, this.fileList.findIndex(item => item.uid == file.uid), file);
    },

    selectCurrentImage (file) {
      this.fileList.map(item => {
        item.isActive = false;
      })
      file.isActive = true;

      this.currentImage = Object.assign({}, file);
      this.setFileList(file);

      if (!file.checked) {
        this.tempCustomAngle = 0;
        this.setTuiImageObject(this.currentImage);
        return;
      }

      let loadImageURL = this.currentImage.base64Url ? this.currentImage.base64Url : this.currentImage.url;
      this.tuiImageEditor.invoke('loadImageFromURL', loadImageURL, this.currentImage.name)
    },

    setTuiImageObject (imageObject) {
      this.tuiImageEditor.invoke('loadImageFromURL', imageObject.url, imageObject.name);
    },
  },
  components: {  
    ImageEditor,
  },
  
}
</script>

<style lang="scss" scoped>
.flip-container {
  .page-wrap {
    padding: 0px;
    .content {
      .main {
        .image-main-container {
          margin-left: 0;
          border-right: 1px solid #eee;
        }
        .image-editor {
          position: relative;
          
          .rule-wrap {
            position: absolute;
            // background-color: #Fff;
            bottom: -10px;
            // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            left: 50%;
            transform: translateX(calc(-50% + 125px));
            padding: 20px;
          }
        }
        .side-menu {
          z-index: 999;
          height: 70px;
          padding: 10px 0;
          padding-top: 30px;
          border: none;
          background-color: #fff;

          .rotate-item {
            cursor: pointer;
            display: inline-block;
            font-weight: normal;
            font-size: 11px;
            margin: 0 9px 0 9px;

            img {
              display: block;
              width: 28px;
              height: 28px;
            }
            label {
              display: block;
              margin-top: 10px;
            }
          }
        }
        .image-list {
          margin-left: 248px;
          width: calc(100% - 248px);
        }

        /deep/ .tui-image-editor-container .tui-image-editor-main {
          top: 0px;
        }

        //  隐藏帮助按钮
        /deep/ .tui-image-editor-help-menu {
          display: none;
        } 

        /deep/ .tui-image-editor-header {
          z-index: 10;
          // display: none;
        }

        /deep/ .tui-image-editor-submenu {
          display: block;

          .cancel-custom {
            margin-top: 8px;
            font-weight: 600;
            width: 98px;
            color: #fff;
            background-color: #333333;
          }

          .cancel-custom:hover {
            background-color: #eee;
            border-color: #eee;
          }
        }

        /deep/ .tui-image-editor-menu-flip {
          display: block;
          margin-top: 50px;
        }

        /deep/ .tui-image-editor-wrap {
          width: calc(100% - 248px) !important;
        }

        /deep/ .tui-image-editor {
          left: 0 !important;
        }

        /deep/ .tui-image-editor-button.resetFlip {
          display: none;
        }

        /deep/ .tie-flip-button {
          padding: 10px 7px;
          .cancel {
            display: none;
          }
          & > li:nth-child(3) {
            display: none;
          }
          & > li {
             width: 100%;
            padding: 7px 0;
            margin-top: 0px;

            .title-label {
              float: left;
              color: #8492a6;
              font-size: 14px;
              line-height: 40px;
              width: 60px;
            }

            .tui-image-editor-button.flipX {
              margin-right: 50px;
            }
          }
        }

        /deep/ .tui-image-editor-partition {
          div {
            color: #eff2f6;
            border-bottom: 1px solid #eff2f6;
          }
        }

        .upload-tips {
          transform: translate(-50% + 74, -50%);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/images/flip/index.vue